import { useContext } from "react";
import { State, StateContext } from "../../state";
import { TrackList } from "./tour_list";
import { TourMap } from "../map";

export const FullTrackList = () => {
 
    return (
        <TrackList full />
    );
}

export const FullMappList = () => {
    return (
        <TrackList mode="map" full/>
    )
}